import Fetch from '../fetch.js';
import {KjApi} from "../api";

export default function (param) {

    let api =KjApi.getSharingCodeToken;
    let paramData = param;

    const promise = new Promise(function (resolve, reject) {

        Fetch(api, {
            method:"POST",
            data: paramData,
            customError: true
        }).then(
            (data) =>{
                if(data.token){
                    localStorage.setItem('Token', data.token);
                }
                resolve(data);
            },
            (error)=>{
                console.log(error);
            }
        );
    });

    return promise;
}
